// extracted by mini-css-extract-plugin
module.exports = {"badge":"CountBadge_badge__mcQoH"};